import React from "react";

import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Input,
    FormGroup,
	Label,
	Table
} from "reactstrap";
import moment from "moment";
import { createSellerRequest, updateSellerRequest, getSellerRequest } from "../../api/seller";	
import { getSellerCommissionsRequest, createSellerCommissionRequest, deleteSellerCommissionRequest } from "../../api/sellerCommissions";
import { getBrokersRequest } from "../../api/broker"
import Async from 'react-select/async';

class SellerForm extends React.Component {

    constructor(props) {
		super(props);
		this.state = {
			seller: null,
			error: null,
			saving: false,
			filtersBrokers: null,
			showCommissionForm: false,
			commissionForm: {
				year: '',
				isVAT: null,
				holdingTax: 0
			},
			filtersCommissions: {
				year: ''
			},
			sellerCommissions: [],
			savingCommission: false
		}
	}

    async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');

		if (id) {
			try {
				const seller = await getSellerRequest(id);

				if(seller.broker) {
					const broker = seller.broker;
					seller.selectedBroker = {
						label: `${broker.name}`,
						value: broker._id
					}

				}

				// Load seller commissions
				const commissionsResponse = await getSellerCommissionsRequest({ seller: id });
				this.setState({ 
					sellerCommissions: commissionsResponse.sellerCommissions || [],
					seller 
				});

			} catch(err) {
				this.setState({
					error: err.message || 'There was an error fetching seller'
				});
			}
		} else {
			this.setState({
				seller: {
					name: '',
				}
			})
		}
	}
    goTo = (path) => this.props.history.push(path);

	save = async () => {
		this.setState({
			saving: true
		})

		const { seller } = this.state;
		const { _id } = seller;
		try {
			if (_id) {
				await updateSellerRequest(seller);
			} else {
				await createSellerRequest(seller);
			}
			this.setState({
				saving: false
			})
			this.goTo('/sellers');
		} catch (err) {
			console.log(err, "error");
			this.setState({
				error: err.message || 'There was an error saving seller',
				saving: false
			})
		}
	
	}

    onChangeField = (e) => {
		const { target } = e;
		const { name, value } = target;
		
		// Handle nested companyAddress fields
		if(name.includes('companyAddress.')) {
			const field = name.split('.')[1];
			this.setState(prevState => ({
				seller: {
					...prevState.seller,
					companyAddress: {
						...prevState.seller.companyAddress,
						[field]: value
					}
				},
			}));
			return;
		}
		
		// Handle isVatable conversion to boolean
		if(name === 'isVatable') {
			this.setState(prevState => ({
				seller: {
					...prevState.seller,
					[name]: value === 'true',
				},
			}));
			return;
		}

		this.setState(prevState => ({
			seller: {
				...prevState.seller,
				[name]: value,
			},
		}));
	}

	createSeller = async () => {
		this.setState({
			saving: true
		})

		const { seller } = this.state;
		
		try {
			if (seller._id) {
				await updateSellerRequest(seller);
			} else {
				await createSellerRequest(seller);
				this.setState({
					saving: false
				})
				this.goTo('/sellers');
			}
		} catch (err) {
			console.log(err, "error");
			this.setState({
				error: err.message || 'There was an error saving seller',
				saving: false
			})
		}
		
		createSellerRequest()
	}

	loadBrokers = async (search, callback) => {
		const { filtersBrokers } = this.state;

		this.setState({
			filtersBrokers: {
				...filtersBrokers,
				search
			}
		})
		if(search) {
			const brokerResponse = await getBrokersRequest(filtersBrokers);
			const brokers = brokerResponse.brokers.map(broker => {
				return {
					data: broker,
					label: `${broker.name}`,
					value: broker._id
				}
			})
			callback(brokers);
		}
	}

	onSelectChange = (key) => (object) => {
		this.setState(prevState => ({
			seller: {
				...prevState.seller,
				[key]: object,
			},
		}));
	}

	handleCommissionChange = (e) => {
		const { target } = e;
		const { name, value } = target;
		this.setState(prevState => ({
			commissionForm: {
				...prevState.commissionForm,
				[name]: value
			}
		}));
	}

	toggleCommissionForm = () => {
		this.setState(prevState => ({
			showCommissionForm: !prevState.showCommissionForm,
			commissionForm: {
				year: new Date().getFullYear(),
				isVAT: null,
				holdingTax: 0
			}
		}));
	}

	addCommission = async () => {
		const { commissionForm, seller } = this.state;
		if (!commissionForm.year || commissionForm.isVAT === null || !commissionForm.holdingTax) {
			this.setState({ error: 'Please fill in all required fields' });
			return;
		}

		this.setState({ savingCommission: true });
		try {
			const commissionData = {
				...commissionForm,
				seller: seller._id,
			};

			await createSellerCommissionRequest(commissionData);
			
			// Refresh commissions list
			const commissionsResponse = await getSellerCommissionsRequest({ 
				seller: seller._id,
				year: this.state.selectedYear 
			});
			
			this.setState({
				sellerCommissions: commissionsResponse.sellerCommissions || [],
				showCommissionForm: false,
				savingCommission: false,
				commissionForm: {
					year: new Date().getFullYear(),
					isVAT: null,
					holdingTax: 0
				}
			});
		} catch (error) {
			this.setState({ 
				error: error.message || 'Error creating commission',
				savingCommission: false
			});
		}
	}

	deleteCommission = async (id) => {
		try {
			await deleteSellerCommissionRequest(id);
			const { seller } = this.state;
			const commissionsResponse = await getSellerCommissionsRequest({ 
				seller: seller._id,
				year: this.state.selectedYear 
			});
			this.setState({ sellerCommissions: commissionsResponse.sellerCommissions || [] });
		} catch (error) {
			this.setState({ error: error.message || 'Error deleting commission' });
		}
	}

	filterCommissionsByYear = async (year) => {
		const { seller } = this.state;
		this.setState({ selectedYear: year });
		const commissionsResponse = await getSellerCommissionsRequest({ 
			seller: seller._id,
			year 
		});
		this.setState({ sellerCommissions: commissionsResponse.sellerCommissions || [] });
	}

    render() {

		const {
			seller = {},
			error = null,
			saving
		} = this.state;

		const {
			_id,
			first_name,
			last_name,
			gender,
			email,
			phone,
			selectedBroker,
			dateOfBirth,
			isVatable,
			companyAddress,
			prcNumber,
			prcDate,
			pcrExpiration
		} = seller || {};

		
        return (
			<>
                <div className="content">
                <Row>
                    <Col md="12">
                    <Card>
                        <CardHeader>
                            <CardTitle className="d-inline-block" tag="h4">
                                Seller
                            </CardTitle>
                            <Button
								className="float-right"
								color="default"
								onClick={() => this.goTo('/sellers')}
                            >
							Back
                  			</Button>
                        </CardHeader>
						<CardBody>
							<Row>
								<Col sm={12} md={6}>
									<FormGroup>
										<Label>First Name <span className="required-start">*</span></Label>
										<Input
											type="text"
											name="first_name"
											value={first_name || ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
								<Col sm={12} md={6}>
									<FormGroup>
										<Label>Last Name <span className="required-start">*</span></Label>
										<Input
											type="text"
											name="last_name"
											value={last_name || ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col sm={12} md={6}>
									<FormGroup>
										<Label>Gender</Label>
										<Input
											type="select"
											name="gender"
											value={gender || ''}
											className={gender ? '' : 'select__placeholder'}
											onChange={this.onChangeField}
										>
											<option value=''>--SELECT--</option>
											<option value='Male'>Male</option>
											<option value='Female'>Female</option>
										</Input>
									</FormGroup>
								</Col>
								<Col sm={12} md={6}>
									<FormGroup>
										<Label>Date of Birth</Label>
										<Input
											type="date"
											name="dateOfBirth"
											value={dateOfBirth ? moment(dateOfBirth).format('YYYY-MM-DD') : ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col sm={12} md={12}>
									<FormGroup>
										<Label>Email Address <span className="required-start">*</span></Label>
										<Input
											type="text"
											name="email"
											value={email || ''}
											onChange={this.onChangeField}
											
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col sm={12} md={12}>
									<FormGroup>
										<Label>Broker</Label>
										<Async
											value={selectedBroker}
											name="selectedSeller"
											options={[]}
											loadOptions={this.loadBrokers}
											isDisabled={_id ? true : false}
											className="basic-multi-select"
											classNamePrefix="select"
											onChange={this.onSelectChange('selectedBroker')}
											placeholder="Search broker by name or email"
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col sm={12} md={6}>
									<FormGroup>
										<Label>Contact Numbers/Mobile</Label>
										<Input
											type="text"
											name="phone"
											value={phone || ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								
								<Col sm={12}>
									<FormGroup>
										<Label>Is Vatable</Label>
										<Input
											type="select"
											name="isVatable"
											value={isVatable || false}
											onChange={this.onChangeField}
										>
											<option value={false}>No</option>
											<option value={true}>Yes</option>
										</Input>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col sm={12}>
									<FormGroup>
										<Label>Company Address</Label>
										<Input
											type="text"
											name="companyAddress.street"
											placeholder="Street"
											value={companyAddress?.street || ''}
											onChange={this.onChangeField}
										/>
										<Input
											type="text"
											name="companyAddress.city"
											placeholder="City"
											className="mt-2"
											value={companyAddress?.city || ''}
											onChange={this.onChangeField}
										/>
										<Input
											type="text"
											name="companyAddress.state"
											placeholder="State"
											className="mt-2"
											value={companyAddress?.state || ''}
											onChange={this.onChangeField}
										/>
										<Input
											type="text"
											name="companyAddress.country"
											placeholder="Country"
											className="mt-2"
											value={companyAddress?.country || ''}
											onChange={this.onChangeField}
										/>
										<Input
											type="text"
											name="companyAddress.zipCode"
											placeholder="Zip Code"
											className="mt-2"
											value={companyAddress?.zipCode || ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col sm={12} md={4}>
									<FormGroup>
										<Label>PRC Number</Label>
										<Input
											type="text"
											name="prcNumber"
											value={prcNumber || ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
								<Col sm={12} md={4}>
									<FormGroup>
										<Label>PRC Date</Label>
										<Input
											type="date"
											name="prcDate"
											value={prcDate ? moment(prcDate).format('YYYY-MM-DD') : ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
								<Col sm={12} md={4}>
									<FormGroup>
										<Label>PRC Expiration</Label>
										<Input
											type="date"
											name="pcrExpiration"
											value={pcrExpiration ? moment(pcrExpiration).format('YYYY-MM-DD') : ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
							<Card className="detail-card">
								<CardHeader>
									<h3>Commission information <i role="button" onClick={this.toggleCommissionForm} className="tim-icons icon-simple-add ml-2 cursor-pointer pull-right" /></h3>
								</CardHeader>
								<CardBody>
									{this.state.showCommissionForm && (
										<>
											<Row>
												<Col sm={12} md={6}>
													<FormGroup>
														<Label>Year <span className="required-start">*</span></Label>
														<Input
															type="number"
															name="year"
															value={this.state.commissionForm.year}
															onChange={this.handleCommissionChange}
															placeholder="Enter year"
														/>
													</FormGroup>
												</Col>
												<Col sm={12} md={6}>
													<FormGroup>
														<Label>Is VAT <span className="required-start">*</span></Label>
														<Input
															type="select"
															name="isVAT"
															value={this.state.commissionForm.isVAT}
															onChange={this.handleCommissionChange}
														>
															<option value={null}>--SELECT--</option>
															<option value={false}>No</option>
															<option value={true}>Yes</option>
														</Input>
													</FormGroup>
												</Col>
												<Col sm={12} md={6}>
												<FormGroup>
													<Label>Holding tax <span className="required-start">*</span></Label>
													<Input
														type="number"
														name="holdingTax"
														value={this.state.commissionForm.holdingTax}
														onChange={this.handleCommissionChange}
														placeholder="Enter percentage"
													/>
												</FormGroup>
												</Col>
											</Row>
											<Row className="mt-4">
												<Col sm={12} className="text-right">
													<Button
														color="secondary"
														className="mr-2"
														onClick={this.toggleCommissionForm}
														disabled={this.state.savingCommission}
													>
														Cancel
													</Button>
													<Button
														color="primary"
														onClick={this.addCommission}
														disabled={this.state.savingCommission}
													>
														{this.state.savingCommission ? "Saving..." : "Save Commission"}
													</Button>
												</Col>
											</Row>
										</>
									)}

									<Row className="mt-4">
										<Col sm={12}>
											<FormGroup>
												<Label>Filter by Year</Label>
												<Input
													type="select"
													value={this.state.selectedYear}
													onChange={(e) => this.filterCommissionsByYear(e.target.value)}
													className={this.state.selectedYear ? "" : ' select__placeholder'}
												>
													<option value="">All Years</option>
													{Array.from(new Set(this.state.sellerCommissions.map(c => c.year))).sort((a, b) => b - a).map(year => (
														<option key={year} value={year}>{year}</option>
													))}
												</Input>
											</FormGroup>
										</Col>
									</Row>

									<Row className="mt-4">
										<Col sm={12}>
											<div className="table-responsive">
												{this.state.sellerCommissions.length > 0 ? (
													<Table>
														<thead>
															<tr>
																<th>Year</th>
																<th>Is VAT</th>
																<th>Holding Tax</th>
																<th>Actions</th>
															</tr>
														</thead>
														<tbody>
															{this.state.sellerCommissions
																.sort((a, b) => b.year - a.year)
																.map((commission, index) => (
																	<tr key={index}>
																		<td>{commission.year}</td>
																		<td>{commission.isVAT ? 'Yes' : 'No'}</td>
																		<td>{commission.holdingTax}%</td>
																		<td>
																			<i 
																				onClick={() => this.deleteCommission(commission._id)}
																				className="tim-icons icon-trash-simple cursor-pointer"
																			/>
																		</td>
																	</tr>
																))}
														</tbody>
													</Table>
												) : (
													<div className="text-center py-4">
														<p className="text-muted">No commission entries found.</p>
													</div>
												)}
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
							</Row>

							{error ? <div className="alert alert-danger mt-3">
									<span>{error}</span>
								</div> : null
							}

							<Button color="primary" block={false} className="mb-4" onClick={this.save}>
								{saving
									? "Saving..."
									: _id
										? "Save Changes"
										: "Save Seller"
								}
							</Button>
						</CardBody>
                    </Card>
                    </Col>
                </Row>
                </div>
            </>
        )
    	
	}
}

export default SellerForm;